import React, { useEffect, useState } from "react";
import {
  getAllWorkspaceStatusBySpace,
  getCurrentWorkspaceId,
  startApiCall,
} from "../../../global-functions/globalFunctions";
import ApiCall from "../../../api/ApiCall";
import { taskEndpoint } from "../../../api/Endpoints";
import TaskHeader from "../TaskHeader";
import { useSelector } from "react-redux";
import TaskListTable from "../Views/TaskListTable";
import FooterPagination from "../../../components/Pagination/FooterPagination";
import CalendarView from "../Views/CalendarView";
import DataLoader from "../../../components/Loaders/DataLoader/DataLoader";
import NoData from "../../../components/NoData/NoData";
import NoTask from "../NoTask";
import TaskDetailsModal from "../TaskDetailsModal/TaskDetailsModal";
import ChangeDuedate from "../../../components/ChangeDuedate/ChangeDuedate";
import { AssignEmployee } from "../AssignEmployee";
import { DateRange } from "../Filters/DateRange";
import { DueDate } from "../Filters/DueDate";
import UserInfoModal from "../../../components/UserInfoModal/UserInfoModal";
import ResetFilterWithChip from "../Filters/ResetFilterWithChip";

function AllTask() {
  const user = useSelector((state) => state.user);
  const [loader, setloader] = useState(false);
  const [loader3, setloader3] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");
  const [taskData, settaskData] = useState([]);
  const [search, setSearch] = useState("");
  const [subTask, setsubTask] = useState([]);
  const [selectedFilterType, setselectedFilterType] = useState("");
  const taskFilters = ["Date Range", "Due Date"];
  const [dueDateForFilter, setdueDateForFilter] = useState("");
  const [startDate, setstartDate] = useState("");
  const [endDate, setendDate] = useState("");
  const [taskStatus, settaskStatus] = useState([]);
  const [taskStatusLoader, settaskStatusLoader] = useState(false);
  const [selectedTaskStatus, setselectedTaskStatus] = useState({
    statusName: "All Status",
    color: "#c8c8c8",
  });
  const [selectedTaskPriority, setselectedTaskPriority] = useState({
    name: "All Priority",
    color: "#c8c8c8",
    value: "",
  });
  const [isFilteredModal, setisFilteredModal] = useState(false);
  const [isFilterReset, setisFilterReset] = useState(false);
  const [selectedTask, setselectedTask] = useState([]);
  const [taskDetailsModal, settaskDetailsModal] = useState(false);
  const [isAssigneeEmployeeModal, setisAssigneeEmployeeModal] = useState(false);
  const [selectedView, setSelectedView] = useState(
    localStorage.getItem("taskview")
      ? localStorage.getItem("taskview")
      : "Table View"
  );

  const [editDueDate, seteditDuedDate] = useState(false);
  const [taskId, settaskId] = useState([]);

  // ****** SET LIST AND SPACENAME ******
  const [listName, setListName] = useState("");
  const [spaceName, setSpaceName] = useState("");

  // ****** PAGINATION ******
  const [page, setPage] = useState(1);
  const [pageLimit, setpageLimit] = useState(10);
  const [count, setcount] = useState(0);
  const [totalPages, settotalPages] = useState(0);

  // ****** FOR USER DETILS ******
  const [userInfoData, setuserInfoData] = useState([]);

  const [listOrSpaceId, setListOrSpaceId] = useState("");

  const handleChangePriority = (pr) => {
    setselectedTaskPriority(pr);
  };
  const handleChangeStatus = (status) => {
    setselectedTaskStatus(status);
  };

  const handleGetAllTaskStatus = async (spaceId) => {
    startApiCall(null, settaskStatusLoader);
    const res = await getAllWorkspaceStatusBySpace(spaceId);
    settaskStatus([...res]);
    settaskStatusLoader(false);
  };

  const handleSubTask = async (taskId) => {
    seterrorMessage("");
    setloader3((prevLoading) => ({
      ...prevLoading,
      [taskId]: true,
    }));
    setTimeout(() => {
      setloader3((prevLoading) => ({
        ...prevLoading,
        [taskId]: false,
      }));
    }, 50000);
    const sendData = {
      page: 1,
      limit: 500,
      employeeId: user?._id,
      filters: {
        businessId: getCurrentWorkspaceId(),
        maintaskId: taskId,
        taskType: "subtask",
      },
    };
    const res = await ApiCall("post", taskEndpoint.getTask, sendData);
    if (res?.success) {
      setsubTask((prevSubtaskData) => ({
        ...prevSubtaskData,
        [taskId]: res?.task?.data,
      }));
      setloader3((prevLoading) => ({
        ...prevLoading,
        [taskId]: false,
      }));
    } else {
      setloader3((prevLoading) => ({
        ...prevLoading,
        [taskId]: false,
      }));
      seterrorMessage(res.error);
    }
  };

  const handleGetTask = async (e) => {
    e && e.preventDefault();
    startApiCall(seterrorMessage, setloader);
    const sendData = {
      page: page,
      limit: pageLimit,
      employeeId: user?._id,
      filters: {
        businessId: getCurrentWorkspaceId(),
        taskType: "maintask",
        searchKey: search,
        startDate: startDate,
        endDate: endDate,
        dueDate: dueDateForFilter,
        priority: selectedTaskPriority?.value,
        status:
          selectedTaskStatus?.statusName === "All Status"
            ? ""
            : selectedTaskStatus?._id,
      },
    };
    const res = await ApiCall("post", taskEndpoint.getTask, sendData);
    if (res?.success) {
      setisFilteredModal(false);
      setisFilterReset(false);
      settaskData(res?.task?.data);
      setcount(res?.task?.totalCounts);
      settotalPages(res?.task?.totalPages);
      setloader(false);
    } else {
      setloader(false);
      seterrorMessage(res.error);
    }
  };

  useEffect(() => {
    handleGetTask();
  }, [
    search,
    selectedTaskStatus,
    selectedTaskPriority,
    selectedView,
    page,
    pageLimit,
  ]);

  useEffect(() => {
    if (isFilterReset) {
      handleGetTask();
    }
  }, [isFilterReset]);

  const handleResetFilters = (type, isReset) => {
    if (type === "Date Range") {
      setstartDate("");
      setendDate("");
    } else if (type === "Due Date") {
      setdueDateForFilter("");
    } else if (type === "Status") {
      setselectedTaskStatus({
        statusName: "All Status",
        color: "#c8c8c8",
      });
    } else if (type === "Priority") {
      setselectedTaskPriority({
        name: "All Priority",
        color: "#c8c8c8",
        value: "",
      });
    }
    setisFilteredModal(false);
    setisFilterReset(isReset);
  };
  return (
    <div className="todoapp-wrap">
      <div class="todoapp-content">
        <div class="todoapp-detail-wrap">
          <TaskHeader
            taskFilters={taskFilters}
            setselectedFilterType={setselectedFilterType}
            setSearch={setSearch}
            search={search}
            handleGetTask={handleGetTask}
            handleGetAllTaskStatus={handleGetAllTaskStatus}
            taskStatus={taskStatus}
            taskStatusLoader={taskStatusLoader}
            handleChangeStatus={handleChangeStatus}
            selectedTaskStatus={selectedTaskStatus}
            handleChangePriority={handleChangePriority}
            selectedTaskPriority={selectedTaskPriority}
            setisFilteredModal={setisFilteredModal}
            selectedView={selectedView}
            setSelectedView={setSelectedView}
            setPage={setPage}
            AllTask={true}
            data={taskData}
          />
            <ResetFilterWithChip
            dueDateForFilter={dueDateForFilter}
            startDate={startDate}
            endDate={endDate}
            selectedTaskStatus={selectedTaskStatus}
            selectedTaskPriority={selectedTaskPriority}
            handleResetFilters={handleResetFilters}
          />
          <div className="todo-body">
            <div className="nicescroll-bar">
              {selectedView === "Table View" &&
                !loader &&
                taskData?.length > 0 && (
                  <>
                    <TaskListTable
                      taskData={taskData}
                      handleGetTask={handleGetTask}
                      subTask={subTask}
                      handleSubTask={handleSubTask}
                      loader3={loader3}
                      setloader3={setloader3}
                      //new
                      setselectedTask={setselectedTask}
                      settaskDetailsModal={settaskDetailsModal}
                      handleGetAllTaskStatus={handleGetAllTaskStatus}
                      taskStatus={taskStatus}
                      taskStatusLoader={taskStatusLoader}
                      setisAssigneeEmployeeModal={setisAssigneeEmployeeModal}
                      page={page}
                      pageLimit={pageLimit}
                      setuserInfoData={setuserInfoData}
                      seteditDuedDate={seteditDuedDate}
                      settaskId={settaskId}
                      isAssigned={false}
                      AllTask={true}
                      setListOrSpaceId={setListOrSpaceId}
                      listOrSpaceId={listOrSpaceId}
                    />
                    <FooterPagination
                      setpageLimit={setpageLimit}
                      pageLimit={pageLimit}
                      setPage={setPage}
                      page={page}
                      totalPages={totalPages}
                      count={count}
                      dataLength={taskData?.length}
                      align={"start"}
                    />
                  </>
                )}

              {/* {selectedView === "Board View" && !loader && (
                <KanbanView
                  selectedView={selectedView}
                  id={id}
                  taskData={allTasks}
                  settaskData={setAllTasks}
                  setselectedTask={setselectedTask}
                  settaskDetailsModal={settaskDetailsModal}
                />
              )} */}

              {selectedView === "Calendar View" && !loader && (
                <CalendarView
                  taskData={taskData}
                  settaskDetailsModal={settaskDetailsModal}
                  setselectedTask={setselectedTask}
                />
              )}

              {loader && <DataLoader title="Your task of list is loading..." />}
              {!loader && taskData?.length === 0 && search === "" && <NoTask />}
              {!loader && search !== "" && taskData?.length === 0 && (
                <NoData title={`No Task`} />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ************ FILTER TASK *********** */}
      {isFilteredModal && (
        <div
          className={`modal fade add-new-contact mt-10 ${
            isFilteredModal ? "show" : ""
          }`}
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
          style={{ display: isFilteredModal ? "block" : "none" }}
        >
          <form onSubmit={handleGetTask}>
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-body">
                  <h5>Filter by {selectedFilterType}</h5>
                  <div className="dropdown-divider"></div>
                  {selectedFilterType === "Date Range" && (
                    <DateRange
                      startDate={startDate}
                      setstartDate={setstartDate}
                      endDate={endDate}
                      setendDate={setendDate}
                      mainLoader={loader}
                      handleResetFilters={handleResetFilters}
                    />
                  )}
                  {selectedFilterType === "Due Date" && (
                    <DueDate
                      setdueDateForFilter={setdueDateForFilter}
                      dueDateForFilter={dueDateForFilter}
                      mainLoader={loader}
                      handleResetFilters={handleResetFilters}
                    />
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      )}

      {/* ************ CHANGE DUE DATE *********** */}
      {editDueDate && (
        <ChangeDuedate
          seteditDuedDate={seteditDuedDate}
          taskId={taskId}
          editDueDate={editDueDate}
          taskType={taskId?.taskType}
          handleGetTaskDetails={handleGetTask}
        />
      )}
      {/* ************  TASK DETAILS *********** */}
      {taskDetailsModal && (
        <TaskDetailsModal
          taskId={
            selectedView === "Calendar View" ? selectedTask : selectedTask?._id
          }
          taskDetailsModal={taskDetailsModal}
          settaskDetailsModal={settaskDetailsModal}
          listName={listName}
          spaceName={spaceName}
          isShowSpace={true}
        />
      )}
      {isAssigneeEmployeeModal && (
        <AssignEmployee
          setisAssigneeEmployeeModal={setisAssigneeEmployeeModal}
          isAssigneeEmployeeModal={isAssigneeEmployeeModal}
          listId={listOrSpaceId}
          user={user}
          selectedTask={selectedTask}
          handleGetTask={handleGetTask}
        />
      )}
      <UserInfoModal user={userInfoData} />
    </div>
  );
}

export default AllTask;
